import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { apiPost, apiPatch } from '~/util/api'
import useTranslation from '../shared/TranslationProvider'

export const useReminderForm = ({ reminder, onSuccess }) => {
  const { t } = useTranslation('ReminderDialog')

  const schema = {
    due_date: z.union([z.date(), z.null(), z.string()]),
    content: z.string().min(2, {
      message: t('please_add_a_reminder'),
    }),
  }

  const defaultValues = {
    due_date: reminder?.due_date?.replace(/-/g, '/') || null,
    content: reminder?.content || '',
  }

  const form = useForm({
    resolver: zodResolver(z.object(schema)),
    defaultValues,
  })

  const onSubmit = (values) => {
    reminderMutation.mutate(values)
  }

  const mutationFn = async (values) => {
    const data = {
      reminder: {
        due_date: values.due_date,
        content: values.content,
      },
    }

    const baseUrl = '/reminders'

    return reminder
      ? await apiPatch(`${baseUrl}/${reminder.id}.json`, data)
      : await apiPost(`${baseUrl}.json`, data)
  }

  const queryClient = useQueryClient()

  const reminderMutation = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries(['reminders'])
      onSuccess()
    },
  })

  const { isPending, isError, isSuccess, error } = reminderMutation

  return { form, onSubmit, isPending, isError, isSuccess, error }
}
